import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'translateproject'
})
export class TranslateprojectPipe implements PipeTransform {
  constructor() {}
  transform(value: string): string {
    if (value.indexOf('.WT') > -1) {
      value = value.replace('.WT', environment.multisite.view.toUpperCase());
    }
    return value;
  }
}
